// src/components/FontSetup.jsx
import React from "react";

const FontSetup = () => {
  return (
    <style>
      {`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700&family=Roboto:wght@400;500&display=swap');

        body {
          font-family: 'Roboto', sans-serif;
        }

        h1, h2, h3, h4, h5, h6 {
          font-family: 'Poppins', sans-serif;
        }

        button, input, textarea, select {
          font-family: 'Roboto', sans-serif;
        }
      `}
    </style>
  );
};

export default FontSetup;
